import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GisComponent } from './components/geoportal/gis/gis.component'
import { MisComponent } from './components/mis/mis.component';
import { SubmitdataComponent } from './components/submitdata/submitdata.component';
import { ResetComponent } from './components/reset/reset.component';
import { WhatsNewComponent } from './components/whats-new/whats-new.component';
import { GdpmsdashboardComponent } from './components/gdpmsdashboard/gdpmsdashboard.component';


const routes: Routes = [
  { path: '', redirectTo: 'gis/', pathMatch: 'full' },
  { path: 'gis/:parentLocName', component: GisComponent},
  { path: 'gis', redirectTo: 'gis/'},
  {path : 'mis', component:MisComponent},
  {path : 'submitdata',component : SubmitdataComponent},
  {path : 'reset',component : ResetComponent},
  {path : 'whatsNew',component : WhatsNewComponent},
  {path : 'gdpmsdashboard', component : GdpmsdashboardComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
